import { v4 as uuidv4 } from "uuid";

export const types = {
    CREATE_TASK: "gantt/CREATE_TASK",
    EDIT_TASK: "gantt/EDIT_TASK",
    DELETE_TASK: "gantt/DELETE_TASK",
    MOVE_TASK: "gantt/MOVE_TASK",
    SET_TASKS: "gantt/SET_TASKS",

    FETCH_GANTT_REQUEST: "gantt/FETCH_GANTT_REQUEST",
    FETCH_GANTT_SUCCESS: "gantt/FETCH_GANTT_SUCCESS",
    FETCH_GANTT_ERROR: "gantt/FETCH_GANTT_ERROR",

    SYNC_GANTT_REQUEST: "gantt/SYNC_GANTT_REQUEST",
    SYNC_GANTT_SUCCESS: "gantt/SYNC_GANTT_SUCCESS",
    SYNC_GANTT_ERROR: "gantt/SYNC_GANTT_ERROR",

    FETCH_GANTT_DASHBOARD_REQUEST: "gantt/FETCH_GANTT_DASHBOARD_REQUEST",
    FETCH_GANTT_DASHBOARD_SUCCESS: "gantt/FETCH_GANTT_DASHBOARD_SUCCESS",
    FETCH_GANTT_DASHBOARD_ERROR: "gantt/FETCH_GANTT_DASHBOARD_ERROR",

    CLEAR_TASKS: "gantt/CLEAR_TASKS",
    CLEAN: "gantt/CLEAN",
    BATCH_UPDATE_TASKS: "gantt/BATCH_UPDATE_TASKS",
};

export const actions = {
    createTask: ({
        id,
        name,
        description,
        start,
        end,
        progress,
        projectId,
        dependencies = [],
        interesados_id = [],
        usuarios_id = [],
        type = "task",
        parent_id = null,
        is_critical = false,
        duration = 0,
    }) => ({
        type: types.CREATE_TASK,
        id,
        name,
        description,
        start,
        end,
        progress,
        projectId,
        dependencies,
        interesados_id,
        usuarios_id,
        gantt_type: type,
        parent_id,
        is_critical,
        duration,
    }),

    editTask: ({
        id,
        name,
        description,
        start,
        end,
        progress,
        dependencies = [],
        interesados_id = [],
        usuarios_id,
        type,
        parent_id,
        is_critical,
        duration,
    }) => ({
        type: types.EDIT_TASK,
        id,
        name,
        description,
        start,
        end,
        progress,
        dependencies,
        interesados_id,
        usuarios_id,
        gantt_type: type,
        parent_id,
        is_critical,
        duration,
    }),

    batchUpdateTasks: (updatedTasks) => ({
        type: types.BATCH_UPDATE_TASKS,
        updatedTasks,
    }),

    deleteTask: ({ id, projectId }) => ({
        type: types.DELETE_TASK,
        id,
        projectId,
    }),

    moveTask: ({ id, newStart, newEnd, projectId }) => ({
        type: types.MOVE_TASK,
        id,
        newStart,
        newEnd,
        projectId,
    }),

    setTasks: ({ tasks }) => ({
        type: types.SET_TASKS,
        tasks,
    }),

    fetch: ({ projectId }) => ({
        type: types.FETCH_GANTT_REQUEST,
        projectId,
    }),

    sync: ({ projectId }) => ({
        type: types.SYNC_GANTT_REQUEST,
        projectId,
    }),

    clean: () => ({
        type: types.CLEAN,
    }),
    fetchGanttDashboard: (usuarioId, modo) => ({
        type: types.FETCH_GANTT_DASHBOARD_REQUEST,
        usuarioId,
        modo
    }),
};

const defaultState = {
    tasks: [],
};

export const selectors = {
    getTasks: ({ gantt }) => gantt.tasks || [],
    getState: ({ gantt }) => gantt,
};

const ganttReducer = (state = defaultState, action = {}) => {
    const {
        id,
        name,
        description,
        start,
        end,
        progress,
        tasks,
        dependencies,
        interesados_id,
        usuarios_id,
        gantt_type,
        parent_id,
        is_critical,
        duration,
    } = action;

    switch (action.type) {
        case types.CREATE_TASK: {
            const newTask = {
                id,
                name: name || "Nueva tarea",
                description,
                start_date: start,
                end_date: end,
                progress: progress || 0,
                dependencies: dependencies || [],
                interesados_id: interesados_id || [],
                usuarios_id: usuarios_id || [],
                type: gantt_type || "task",
                parent_id: parent_id || null,
                is_critical: !!is_critical,
                duration: duration || 0,
                status: "pending",
            };

            const currentTasks = Array.isArray(state.tasks) ? state.tasks : [];

            return {
                ...state,
                tasks: [...currentTasks, newTask],
            };
        }

        case types.EDIT_TASK: {
            return {
                ...state,
                tasks: state.tasks.map((t) =>
                    t.id === id
                        ? {
                            ...t,
                            name: name ?? t.name,
                            description: description ?? t.description,
                            start_date: start ?? t.start_date,
                            end_date: end ?? t.end_date,
                            progress:
                                progress !== undefined ? progress : t.progress,
                            dependencies: dependencies ?? t.dependencies ?? [],
                            interesados_id:
                                interesados_id ?? t.interesados_id ?? [],
                            usuarios_id:
                                usuarios_id ?? t.usuarios_id ?? [],
                            type: gantt_type ?? t.type ?? "task",
                            parent_id:
                                parent_id !== undefined
                                    ? parent_id
                                    : t.parent_id ?? null,
                            is_critical:
                                is_critical !== undefined
                                    ? is_critical
                                    : t.is_critical ?? false,
                            duration: duration ?? t.duration ?? 0,
                        }
                        : t
                ),
            };
        }

        case types.BATCH_UPDATE_TASKS: {
            const updatesMap = new Map((action.updatedTasks || []).map(t => [String(t.id), t]));
            return {
                ...state,
                tasks: state.tasks.map((t) => {
                    const update = updatesMap.get(String(t.id));
                    if (update) {
                        return {
                            ...t,
                            ...update,
                        };
                    }
                    return t;
                }),
            };
        }

        case types.DELETE_TASK: {
            return {
                ...state,
                tasks: state.tasks.filter(
                    (t) => t.id !== id && t.parent_id !== id // elimina también subtareas si se borra un grupo
                ),
            };
        }

        case types.MOVE_TASK: {
            return {
                ...state,
                tasks: state.tasks.map((t) =>
                    t.id === id
                        ? {
                            ...t,
                            start_date: action.newStart,
                            end_date: action.newEnd,
                        }
                        : t
                ),
            };
        }

        case types.SET_TASKS: {
            const normalized = Array.isArray(tasks)
                ? tasks
                : tasks?.rows || Object.values(tasks?.byId || {}) || [];

            return {
                ...state,
                tasks: normalized.map((t) => ({
                    ...t,
                    type: t.type || "task",
                    parent_id: t.parent_id || null,
                    is_critical: !!t.is_critical,
                    duration: t.duration || 0,
                })),
            };
        }

        case types.FETCH_GANTT_DASHBOARD_REQUEST:
            return {
                ...state,
                isLoading: true
            };

        case types.FETCH_GANTT_DASHBOARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                tasks: action.payload.map((t) => ({
                    ...t,
                    type: t.type || "task",
                    parent_id: t.parent_id || null,
                    is_critical: !!t.is_critical,
                    duration: t.duration || 0,
                })),
                error: null
            };

        case types.CLEAN:
            return defaultState;

        case types.CLEAR_TASKS:
            return {
                ...state,
                tasks: [],
            };

        default:
            return state;
    }
};

export default ganttReducer;
